import { render } from "./ForgotForm.vue?vue&type=template&id=59fa164e"
import script from "./ForgotForm.vue?vue&type=script&lang=js"
export * from "./ForgotForm.vue?vue&type=script&lang=js"

import "./ForgotForm.vue?vue&type=style&index=0&id=59fa164e&lang=scss"

import exportComponent from "/Users/edvardaskostkevicius/WebstormProjects/rv_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__